export function openSidebar() {
  if (typeof window !== "undefined") {
    document.body.style.overflow = "hidden";
    document.documentElement.style.setProperty("--SideNavigation-slideIn", "1");
  }
}

export function closeSidebar() {
  if (typeof window !== "undefined") {
    document.documentElement.style.removeProperty("--SideNavigation-slideIn");
    document.body.style.removeProperty("overflow");
  }
}

export function toggleSidebar() {
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    const slideIn = window.getComputedStyle(document.documentElement).getPropertyValue("--SideNavigation-slideIn");
    if (slideIn) {
      closeSidebar();
    } else {
      openSidebar();
    }
  }
}

export const writeCookie = (setCookieFunc: any, name: string, value: any, options = {}) => {
  const defaultOptions = {
    path: "/",
    sameSite: "lax",
    ...options,
  };
  setCookieFunc(name, value, defaultOptions);
};

export const readCookie = (cookiesObject: any, name: string) => {
  return cookiesObject[name];
};

export const deleteCookie = (removeCookieFunc: any, name: string, options = {}) => {
  const defaultOptions = {
    path: "/",
    ...options,
  };
  removeCookieFunc(name, defaultOptions);
};

export const formatDate = (dateString: string | null | undefined) => {
  if (!dateString) return "N/A";
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Date";
    return date.toLocaleDateString();
  } catch (e) {
    return "Invalid Date";
  }
};

export function extractInvoiceNumberWithRegex(idString) {
  if (!idString || typeof idString !== "string") {
    return null;
  }
  const match = idString.match(/^\d+/);
  if (match) {
    return parseInt(match[0], 10);
  }
  return null;
}

export const displayOptional = (value: string | number | null | undefined, defaultValue: string = "N/A"): string => {
  if (value === null || value === undefined || String(value).trim() === "") return defaultValue;
  else if (value === "saved_as_draft") return "Saved as Draft";
  return String(value);
};

export const formatDateForInput = (dateInput: string | null | undefined): string => {
  if (!dateInput) return "";
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 10);
};

export const formatIndianCurrency = (value: string): string => {
  const cleaned = value.replace(/[^0-9.]/g, "");
  const number = parseFloat(cleaned);
  if (isNaN(number)) return "";
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};

export const formatDateTable = (dateString: string | null | undefined): string => {
  if (!dateString) return "N/A";
  // try {
  //   const date = new Date(dateString);
  //   if (isNaN(date.getTime())) return dateString;
  //   return date.toLocaleDateString(undefined, {
  //     year: "numeric",
  //     month: "short",
  //     day: "numeric",
  //   });
  // } catch (e) {
  //   return dateString;
  // }

  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");

  return day + "-" + month + "-" + date.getFullYear();
};

export const downloadBase64File = (base64Data, fileName, mimeType) => {
  //decode base64 string
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mimeType });
  // create a link and click it
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.target = "_blank";
  link.click();
}

export function checkUserRole(list1, list2) {

  const common = list1.filter((item) => list2.includes(item));
  if (common.length > 0) {
    return true;
  }
  return false;
}